import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import * as styles from "src/styles/member_card.module.scss"
import Card from "./Card"

export default function MemberCard({ title, image, details }) {
  return (
    <Card>
      <h2 className={styles.card_topic}>{title}</h2>
      <GatsbyImage
        className={styles.card_image}
        image={getImage(image)}
        alt="Member Image"
      />
      <p className={styles.details}>{details}</p>
    </Card>
  )
}
